'use client';

import styled from '@emotion/styled';
import FeatureEntrypoint from '../../../components/common/cards/FeatureEntrypoint';
import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';
import { Css, Flex, Responsive } from '../../../ui';
import DineIcon from '../../../assets/icons/dine.svg';
import BookParkingIcon from '../../../assets/icons/book-parking.svg';

export const BOOK_PARKING_URL =
	'https://parking.orlandoairports.net/book/MCO/Parking?parkingCmd=collectParkingDetails';

export default function FeatureEntryPointSection() {
	return (
		<StyledFlex direction="column">
			<FeatureEntrypoint
				label="Shop & Dine at Orlando Airport"
				icon={<DineIcon aria-label="Dine" />}
				linkTitle="Discover Airport Concessions"
				linkHref={PageRoutes.ShopDineRelax}
			/>
			<FeatureEntrypoint
				label="Guarantee Your Parking Space"
				icon={<BookParkingIcon aria-label="Book Parking" />}
				linkTitle="Reserve Now"
				linkHref={BOOK_PARKING_URL}
			/>
		</StyledFlex>
	);
}

const StyledFlex = styled(Flex)`
	gap: ${Css.pxToRem(24)};
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		gap: ${Css.pxToRem(8)};
	}
`;
